export const LEAD_INDICATORS = [
  {
    id: "total",
    title: "Total de Leads",
    type: "finished",
    icon: "users"
  },
  {
    id: "active",
    title: "Clientes Ativos",
    type: "active",
    icon: "user-check"
  },
  {
    id: 'prospect',
    title: "Prospects",
    type: "awaiting",
    icon: "user-plus"
  },
  {
    id: 'exclient',
    title: "Ex-clientes",
    type: "restricted",
    icon: "user-x"
  },
]

export const LEAD_INDICATORS_NAMES = {
  total: {
    id: "total",
    title: "Total de Leads"
  },
  active: {
    id: "active",
    title: "Cliente ativo"
  },
  prospect: {
    id: 'prospect',
    title: "Prospect",
    type: "awaiting",
    icon: "user-plus"
  },
  exclient: {
    id: 'exclient',
    title: "Ex-cliente",
    type: "restricted",
    icon: "user-x"
  }
}

export const LEAD_COLORS = {
  "Total de Leads": "finished",
  "Cliente ativo": "active",
  "Prospect": "awaiting",
  "Ex-cliente": "restricted"
}

export const LEAD_STEPS = ["Informações", "Endereço", "Classificação"]

export const LEAD_STEP_NAME_ROUTES = [
  "lead-info",
  "lead-address",
  "lead-classification"
]

export const LEAD_STEP_NAME_EDIT_ROUTES = [
  "lead-edit-info",
  "lead-edit-address",
  "lead-edit-classification"
]

export const STATUS_OPTIONS = [
  { value: 1, text: "Prospect" },
  { value: 2, text: "Ativo" },
  { value: 3, text: "Ex-cliente" }
]

export const PERSON_TYPE = {
  LEGAL: "JURIDICA",
  NATURAL: "FISICA"
}

export const CONTACT_TYPE = {
  EMAIL: "EMAIL",
  CELLPHONE: "CELULAR",
  ANOTHER_CONTACT: "FIXO"
}

export const LEAD_IMPORTATION_MAPPING = [
  { excel: "tipo_pessoa", system: "Tipo de Pessoa" },
  { excel: "cpf_cnpj", system: "CPF / CNPJ" },
  { excel: "nome_razao_social", system: "Nome / Razão Social" },
  { excel: "data_nascimento", system: "Data de Nascimento" },
  { excel: "genero", system: "Gênero" },
  { excel: "email", system: "E-mail" },
  { excel: "telefone_celular", system: "Telefone Celular" },
  { excel: "telefone_fixo", system: "Telefone Fixo" },
  { excel: "logradouro", system: "Logradouro" },
  { excel: "numero", system: "Número" },
  { excel: "complemento", system: "Complemento" },
  { excel: "bairro", system: "Bairro" },
  { excel: "cidade", system: "Cidade" },
  { excel: "uf", system: "UF" },
  { excel: "cep", system: "CEP" },
  { excel: "tags", system: "Tags" },
  { excel: "observacoes", system: "Observações" }
]

export const IMPORTATION_LEAD_BASE = "lead_base"

export const IMPORTATION_STATUS = {
  in_progress: "Em Progresso",
  in_queue: "Em Fila",
  success: "Sucesso",
  failed: "Falha"
}

export const DETAILS_TABS = {
  INFORMATION: "information",
  ORDERS: "orders",
  HISTORY: "history",
}

export const DETAILS_TABS_LABELS = [
  "Informações",
  "Pedidos",
  "Histórico",
]

export const PAYMENT_METHODS = {
  DEBITO_AUTOMATICO: "Débito automático",
  BOLETO: "Boleto",
  CREDITO: "Crédito",
  CARNE: "Carne",
}

export const ORDER_STATUS_COLORS = {
  Biometria: "green",
  Concluída: "orange",
  Finalizado: "red"
}

export const HISTORY_TYPES = {
  1: {
    icon: "dollar-sign",
    color: "success"
  },

  2: {
    icon: "briefcase",
    color: "warning"
  },

  3: {
    icon: "message-circle",
    color: "info"
  },

  4: {
    icon: "credit-card",
    color: "danger"
  },

  5: {
    icon: "user",
    color: "purple"
  }
}
